import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isRecording: null,
  fileIdentifier: null,
  lastStatus: null,
  startedAt: null,
}

export const returnVideoRecorderSlice = createSlice({
  name: 'returnVideoRecorder',
  initialState,
  reducers: {
    setRecordingState: (state, action) => {
      state.isRecording = action.payload?.isRecording ? action.payload?.isRecording : null
      state.fileIdentifier = action.payload?.fileIdentifier ? action.payload?.fileIdentifier : null
    },
    setLastStatus: (state, action) => {
      state.lastStatus = action.payload
    },
    setStartedAt: (state, action) => {
      state.startedAt = action.payload
    },
    stopRecording: (state) => {
      state.isRecording = false
      state.startedAt = null
    },
  },
})

export const {
  setRecordingState,
  setLastStatus,
  setStartedAt,
  stopRecording,
} = returnVideoRecorderSlice.actions

export const isRecording = (state) => state.returnVideoRecorder.isRecording
export const fileIdentifier = (state) => state.returnVideoRecorder.fileIdentifier
export const lastStatus = (state) => state.returnVideoRecorder.lastStatus
export const startedAt = (state) => state.returnVideoRecorder.startedAt

export default returnVideoRecorderSlice.reducer
